import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { HomeIcon, MapPinIcon } from '@heroicons/react/24/outline';
import './NotFound.css';
import CenteredHeroNav from "./CenteredHeroNav";

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Log 404 attempts (you can send this to analytics)
  React.useEffect(() => {
    // You could send this to your analytics service:
    // analytics.track('404_page_view', { path: location.pathname });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col theme-gradient-surface">
      {/* Consistent navbar */}
      <CenteredHeroNav />
      {/* Page content */}
      <div className="flex-1 w-full">
        <div className="not-found-container w-full h-full">
          {/* Floating background elements */}
          <div className="floating-elements">
            <div className="float-circle"></div>
            <div className="float-circle"></div>
            <div className="float-circle"></div>
          </div>

          {/* Electric theme decorations */}
          <div className="electric-decoration"></div>

          {/* Main content with glass-morphism - responsive */}
          <div className="not-found-content px-4 sm:px-6 lg:px-8">
            <h1 className="error-404">404</h1>

            <h2 className="error-title">Oops! Page Not Found</h2>

            <p className="error-subtitle">
              Sorry, the page you're looking for doesn't exist or has been moved.
            </p>

            <div className="error-path break-all">
              {location.pathname}
            </div>

            <div className="button-container flex-col sm:flex-row gap-4">
              <button
                className="btn-primary-404 w-full sm:w-auto flex items-center justify-center"
                onClick={() => navigate('/')}
              >
                <HomeIcon className="w-5 h-5 mr-2" />
                Back to Home
              </button>

              <button
                className="btn-secondary-404 w-full sm:w-auto flex items-center justify-center"
                onClick={() => navigate('/locations')}
              >
                <MapPinIcon className="w-5 h-5 mr-2" />
                Browse Locations
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
